///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2021 - 2021
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";
import { useSelector } from "react-redux";

import loadViewColumns from "../../../helpers/loadViewColumns";
import { analyticsView } from "../../../helpers/types";
import {
  filterLoads,
  setColumnWidth,
  sortLoads,
  toggleColumnFilterMenu
} from "../../../slices/analyticsSlice";
import LanesGridBody from "../pricing/LanesGridBody";
import PricingGridHeader from "../pricing/PricingGridHeader";

export const LoadViewGrid = ({ division }) => {
  const {
    analytics: {
      loadView: {
        lanes: loadViewLanes,
        columnFilterMenu,
        columnFilters,
        rangeFilters,
        columnWidths,
        sortField,
        sortOrder
      }
    },
    bidSummary: { summary },
    user: { user }
  } = useSelector(state => state);

  return (
    <div
      data-testid="load-view-grid"
      className="analytics-table-width"
      id="analytics-grid-loadView"
    >
      <div
        style={{ maxHeight: window.screen.height - 240 }}
        className="overflow-x--scroll scroll"
      >
        <table className="bg-white pl-16 pos-relative">
          <PricingGridHeader
            columns={loadViewColumns}
            columnOrder={loadViewColumns.map(m => m.field)}
            sortField={sortField}
            sortOrder={sortOrder}
            columnFilterMenu={columnFilterMenu}
            columnFilters={columnFilters}
            rangeFilters={rangeFilters}
            columnWidths={columnWidths}
            analyticsGridView={analyticsView.loadView}
            setColumnWidth={setColumnWidth}
            toggleColumnFilterMenu={toggleColumnFilterMenu}
            filterPricingLanes={filterLoads}
            sortPricingLanes={sortLoads}
            bidDivision={division ?? summary?.division}
          />
          {loadViewLanes && (
            <LanesGridBody
              columns={loadViewColumns}
              lanes={loadViewLanes}
              offset={0}
              perPage={loadViewLanes.length}
              columnOrder={loadViewColumns.map(m => m.field)}
              bidDivision={division ?? summary?.division}
              userDivision={user?.division}
              analyticsGridView={analyticsView.loadView}
            />
          )}
        </table>
      </div>
    </div>
  );
};

export default LoadViewGrid;
